export class DynamicStyle {
    dynamicClasses : String
    dynamicCSS : Object | string
    titleCSS:  Object | string
    titleClasses: String
  
    constructor() {
      this.dynamicCSS = {}
      this.dynamicClasses = ''
      this.titleCSS = {}
      this.titleClasses = ''
    }
  }


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/classes/dynamicStyle.class.ts